(function () {
  const Core = window.RB.Core;
  const { buff } = window.RB.CardLib;

  window.RB.CardScripts = window.RB.CardScripts || {};
  Object.assign(window.RB.CardScripts, {
    "Lux, Illuminated": {
      triggers: [{
        on: "finalizedCard",
        condSpec: { k: "and", conds: [{ k: "evYou" }, { k: "evType", type: "spell" }, { k: "evCardEnergyAtLeast", n: 5 }] },
        label: "+3 Might this turn",
        program: [buff("source", 3)],
      }],
    },

    "Lady of Luminosity - Starter": {
      triggers: [{
        on: "finalizedCard",
        condSpec: { k: "and", conds: [{ k: "evYou" }, { k: "evType", type: "spell" }, { k: "evCardEnergyAtLeast", n: 5 }] },
        label: "draw 1",
        program: [{ op: "draw", n: 1 }],
      }],
    },

    "Final Spark": {
      play: [{ op: "deal", to: "$t1", n: 8 }],
      targets: [{ bind: "t1", spec: { type: "unit" }, prompt: "Deal 8 to..." }],
    },
  });
})();
